import { render, staticRenderFns } from "./PassengerList.vue?vue&type=template&id=3f1ef771"
import script from "./PassengerList.vue?vue&type=script&lang=ts"
export * from "./PassengerList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports